import { useState } from "react";
import { ExclamationCircleIcon, Flex, Text } from "@paguelofacil/pf-components";
import Input from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en";
import { isValidPhoneNumber } from "react-phone-number-input";

import { CountrySelect } from "./CountrySelect";

import "../../assets/scss/inputs.scss";

export const PhoneInput = ({ country, disabled = false, onChange, placeholder, label, isRequired }) => {
    const [countrySelected, setCountrySelected] = useState({
        value: country || "PA",
        label: "",
        image: `https://purecatamphetamine.github.io/country-flag-icons/3x2/${country || "PA"}.svg`,
        code: "",
    });
    const [inputValue, setInputValue] = useState("123123123");

    const [validationNumber, setValidationNumber] = useState({
        isValid: true,
        errorRequired: "",
    });

    const onChangeInput = value => {
        setInputValue(value);

        let isNumberValid;
        if (value) {
            isNumberValid = isValidPhoneNumber(value);
        }

        if (isNumberValid) {
            onChange(value);
        } else {
            onChange("");
        }

        setValidationNumber({ isValid: isNumberValid, errorRequired: value ? "" : "Campo requerido" });
    };

    const onCountryChange = currentCountry => {
        setCountrySelected(currentCountry);
    };

    return (
        <Flex direction="column" justify="flex-start" align="flex-start" gap="0.25rem">
            <label className="title-info-payment-2">
                {label}
                {isRequired ? (
                    <span style={{ color: "#e11900" }}>&nbsp;*</span>
                ) : (
                    <span style={{ color: "#7D889B", fontWeight: "400" }}>&nbsp;(Opcional)</span>
                )}
            </label>
            <Flex direction="row" wrap="nowrap" width="100%" minW="100%" gap="0.25rem">
                <Flex width="auto" minW="7rem" className="container-select-phone">
                    <CountrySelect labels={en} value={countrySelected} onChange={onCountryChange} />
                </Flex>
                <Flex width="100%" minW="auto">
                    <Input
                        defaultCountry={countrySelected["value"]}
                        disabled={disabled}
                        country={countrySelected["value"]}
                        placeholder={placeholder}
                        value={inputValue}
                        onChange={onChangeInput}
                        onFocus={null}
                        onBlur={null}
                        className="inputs"
                    />
                </Flex>
            </Flex>
            {!validationNumber.isValid || validationNumber.errorRequired ? (
                <Text variant="caption" className="feedback" weight="regular">
                    <Flex direction="row" wrap="nowrap" gap="0.25rem">
                        <ExclamationCircleIcon isFullfill color="#E11900" />{" "}
                        {validationNumber.errorRequired ? "Campo requerido" : "Numero de telefono invalido"}
                    </Flex>
                </Text>
            ) : (
                <></>
            )}
        </Flex>
    );
};
